import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e690cc46"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "image-greeting-container"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "images-Select-Box"
};
const _hoisted_4 = ["onMouseenter"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "mark"
};
const _hoisted_7 = {
  class: "example-pagination-block"
};
import { delReplyById, getMaterial } from '@/api/greeting';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { Check, ZoomIn } from '@element-plus/icons-vue';
export default {
  __name: 'index',
  props: {
    greetingList: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'imageSelected', 'getData', 'changeDialogVisible', 'editGreetingHandler'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const route = useRoute(0);
    const {
      path
    } = route.params;
    const emits = __emit;
    const imageVisibleClosed = () => {
      emits('update:modelValue', false);
    };

    // 获取素材的currentPage
    const currentPage = ref(1);
    const materialList = ref([]);
    const total = ref(0);
    const getMaterialData = async () => {
      const res = await getMaterial(path, 'image', currentPage.value);
      materialList.value = res.item;
      total.value = res.total_count;
    };
    getMaterialData();
    watch(() => props.modelValue, async val => {
      if (val) {
        await getMaterialData();
      }
    });
    const handleCurrentChange = async val => {
      currentPage.value = val;
      await getMaterialData();
    };
    const currentSelectImage = ref({});
    const onSelectImageHandler = (item, select) => {
      currentSelectImage.value = item;
      imageVisibleClosed();
      emits('imageSelected', item);
    };

    /**
     * 删除回复消息
     */
    const delGreetingHandler = async raw => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await delReplyById(raw.id);
        emits('getData');
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {}
    };

    /**
     * 修改
     */
    const editGreetingHandler = raw => {
      emits('changeDialogVisible', true);
      // form.value = { ...row, isChain: Boolean(row.isChain) }
      emits('editGreetingHandler', raw);
    };

    // const markShow = ref(false)
    const currentIndex = ref('');
    const isPreview = ref(false);
    const currentImage = ref({});
    const previewCurrentSelectImage = item => {
      currentImage.value = item;
      isPreview.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: __props.greetingList,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "keyword",
          label: "关键字",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          width: "180"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(row.createTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "modifyTime",
          label: "修改时间",
          width: "180"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(row.modifyTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "value",
          label: "内容"
        }, {
          default: _withCtx(({
            row
          }) => [row.note ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            src: row.note,
            "preview-src-list": [row.note],
            "preview-teleported": "",
            class: "preview-image"
          }, null, 8, ["src", "preview-src-list"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, "暂未上传图片"))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => editGreetingHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => delGreetingHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(_component_el_dialog, {
        title: "选择图片",
        "model-value": __props.modelValue,
        onClosed: imageVisibleClosed,
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: item.media_id,
            class: "select-image-box",
            onMouseenter: $event => currentIndex.value = index,
            onMouseleave: _cache[0] || (_cache[0] = $event => currentIndex.value = '')
          }, [_createElementVNode("img", {
            class: "select-image",
            src: item.url + '?' + new Date().getTime(),
            alt: "",
            referrerpolicy: "no-referrer"
          }, null, 8, _hoisted_5), _createVNode(_Transition, {
            name: "fade"
          }, {
            default: _withCtx(() => [currentIndex.value === index ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_icon, {
              color: "#ffffff",
              size: 20,
              class: "icon",
              onClick: $event => onSelectImageHandler(item)
            }, {
              default: _withCtx(() => [_createVNode(_unref(Check))]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_icon, {
              onClick: $event => previewCurrentSelectImage(item),
              color: "#ffffff",
              size: 20,
              class: "icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ZoomIn))]),
              _: 2
            }, 1032, ["onClick"])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)], 40, _hoisted_4);
        }), 128))]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          total: total.value,
          currentPage: currentPage.value,
          "page-size": 20,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["total", "currentPage"])])]),
        _: 1
      }, 8, ["model-value"]), _createVNode(_component_el_dialog, {
        modelValue: isPreview.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isPreview.value = $event),
        onClose: _cache[2] || (_cache[2] = $event => currentIndex.value = ''),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          src: currentImage.value.url
        }, null, 8, ["src"])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};